export type V10QueueRiskLevel = "low" | "medium" | "high";

export function deriveV10QueueRisk(input: {
  readonly qaFailure: boolean;
  readonly hasChangeRequest: boolean;
  readonly awaitingClient: boolean;
  readonly handoffReady: boolean;
}): V10QueueRiskLevel {
  if (input.qaFailure) return "high";
  if (input.hasChangeRequest || input.awaitingClient) return "medium";
  if (input.handoffReady) return "low";
  return "low";
}

export function humanV10QueueRiskLabel(level: V10QueueRiskLevel): string {
  switch (level) {
    case "high":
      return "High risk";
    case "medium":
      return "Medium risk";
    default:
      return "Low risk";
  }
}
